module.exports = __webpack_public_path__ + "static/media/solidedge.0a588772.png";